import { Checkbox, Divider, message, Spin } from "antd";
import styles from "./styles.module.scss";
import { DeactivateInfo } from "icons";
import { UseLazyApiCall } from "hooks";
import { useCurrentUserContext } from "providers";
import { useState } from "react";
import { ConditionalRenderer } from "components";

export const DeactivateAccount = ({
  closeModal,
  email,
  userDetailsRefetch,
  isActive,
  activationKeys,
}) => {
  const { user } = useCurrentUserContext();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");

  const payload = {
    email: user?.email,
    [activationKeys.payloadAndApiKey]: email,
  };

  const [
    changeActivation,
    {
      data: userActivationData,
      isLoading: userActivationLoading,
      error,
      refetch,
    },
  ] = UseLazyApiCall({
    url: `/internal/${activationKeys.payloadAndApiKey}`,
    method: "POST",
    paramsData: payload,
  });

  const onChange = (e) => {
    const checked = e.target.checked;
    if (checked) {
      seterrorMsg("");
    }
    setIsConfirmed(checked);
  };

  async function activateOrDeactivate() {
    if (!isConfirmed) {
      return seterrorMsg("Required");
    }
    try {
      const res = await changeActivation();
      if (res) {
        message.success("Activation Status changed Successfully");
        setIsConfirmed(false);
        userDetailsRefetch();
        closeModal();
      } else {
        message.error("Something went wrong");
      }
    } catch (error) {
      message.error("Something went wrong");
    }
  }

  const buttons = [
    {
      title: "Cancel",
      clickHandler: () => {
        seterrorMsg("");
        closeModal();
      },
      bgColor: "#6F7174",
    },
    {
      title: `${activationKeys.deActivate} Account`,
      clickHandler: activateOrDeactivate,
      bgColor: isActive ? "#FF3A3A" : "#46B764",
    },
  ];

  return (
    <Spin spinning={userActivationLoading}>
      <div className={styles.deactivateAccount}>
        <Divider />
        <div className={styles.highlight}>
          <div>
            <DeactivateInfo />
          </div>
          <div className={styles.textContainer}>
            <div className={styles.text}>
              You are {activationKeys.deActivating} your account
            </div>
            <div className={styles.parag}>
              For extra security, this requires you to confirm you are{" "}
              {activationKeys.deActivating} account.
            </div>
          </div>
        </div>

        <div className={styles.checkBoxContainer}>
          <Checkbox onChange={onChange}>
            Confirm Account {activationKeys.deActivation}{" "}
          </Checkbox>
          <ConditionalRenderer condition={errorMsg}>
            <span style={{ color: "red" }}>{errorMsg}</span>
          </ConditionalRenderer>
        </div>
        <Divider />
        <div className={styles.btnsContainer}>
          {buttons.map((btn) => (
            <button
              key={btn.title}
              style={{ backgroundColor: `${btn.bgColor}` }}
              onClick={btn.clickHandler}
            >
              {btn.title}
            </button>
          ))}
        </div>
      </div>
    </Spin>
  );
};
